<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-app id="app">
        <v-app-bar
                app
                clipped-left
                color="primary"
                dark
        >
<!--            <span class="title ml-3 mr-5">Deep Work Hours</span>-->
            <v-toolbar-title>Deep Work Hours</v-toolbar-title>
            <div class="flex-grow-1"></div>

            <v-menu
                    left
                    bottom
                    v-if="isLoggedIn"
            >
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item
                            @click="logout"
                    >
                        <v-list-item-title>Logout</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>

        <v-content>
            <v-container
                    fluid
                    class="grey lighten-4 fill-height"
            >
                <v-row
                        justify="center"
                >
                    <v-col
                    >
                        <slot></slot>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>

        <v-bottom-navigation
                color="primary"
                horizontal
                grow
        >
            <template v-for="(item, i) in items">
                <v-btn
                        :to="item.link"
                >
                    <span>{{ item.text }}</span>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-btn>
            </template>
        </v-bottom-navigation>
    </v-app>
</template>

<script>
  import { auth } from '../main'

  export default {
    name: 'app',
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
      items: [
        { icon: 'timer', text: 'Focus', link: '/focus' },
        { icon: 'mdi-finance', text: 'Track', link: '/track' },
      ],
      isLoggedIn: false
    }),
    methods: {
      logout: function () {
        this.$ga.event('Acquisition', 'Logged Out', auth.currentUser.email);
        auth.signOut().then(() => {
          this.$router.replace('/');
        })
      },
    },
    mounted: function () {
      auth.onAuthStateChanged((user) => {
        if (user) {
          this.isLoggedIn = true;
          this.$ga.event('Acquisition', 'Logged In', user.email);
          this.$ga.set('userId', user.email);
        } else {
          this.isLoggedIn = false;
        }
      });
    }
  }
</script>

<style>
    #keep .v-navigation-drawer__border {
        display: none
    }
</style>
